import { dataUserAuthorization } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserAuthorization = /*#__PURE__*/createIcon(dataUserAuthorization)
export default IconUserAuthorization
